import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Crown, ArrowRight } from "@phosphor-icons/react";

/**
 * SubtlePremiumStrip — a single quiet line replacing the loud premium banner on Home.
 *
 * • NK+ subscribers see a compact "NK+ member — perks active" chip with a manage link.
 * • Non-subscribers see a low-contrast, one-line NK+ upsell chip.
 *
 * Deliberately smaller / lower-saturation than NKPlusStatus so it doesn't dominate
 * the Home visual stack; premium subscribers can still see their status but it
 * doesn't feel like an ad, and non-subscribers get a nudge without a "buy me" wall.
 */
export default function SubtlePremiumStrip() {
  const { user } = useAuth();
  const isPremium = !!user?.nk_plus_active;

  if (isPremium) {
    return (
      <Link
        to="/profile"
        data-testid="home-premium-strip"
        className="group flex items-center justify-between gap-3 rounded-sm border border-nk-gold/25 bg-nk-gold/[0.04] px-3 py-2 hover:border-nk-gold/45 hover:bg-nk-gold/[0.07] transition-colors"
      >
        <span className="inline-flex items-center gap-2 text-xs text-nk-gold/85">
          <Crown size={13} weight="fill" className="text-nk-gold" />
          NK+ member · perks active across every mode
        </span>
        <ArrowRight size={11} weight="bold" className="text-nk-gold/60 group-hover:translate-x-0.5 transition-transform" />
      </Link>
    );
  }

  return (
    <Link
      to="/profile?tab=account"
      data-testid="home-premium-strip"
      className="group flex items-center justify-between gap-3 rounded-sm border border-white/8 bg-white/[0.02] px-3 py-2 hover:border-nk-gold/25 hover:bg-nk-gold/[0.04] transition-colors"
    >
      <span className="inline-flex items-center gap-2 text-xs text-white/60 group-hover:text-white/80 transition-colors">
        <Crown size={13} weight="duotone" className="text-nk-gold/60 group-hover:text-nk-gold transition-colors" />
        <span>NK+ · lifelines, no ads, priority Duel queue</span>
      </span>
      <ArrowRight size={11} weight="bold" className="text-white/40 group-hover:text-nk-gold group-hover:translate-x-0.5 transition-all" />
    </Link>
  );
}
